import { AzureDataExplorerCopySourceAdapter } from 'app/model/adapters/activities/copysource/azure-data-explorer.copysource.adapter';
import { AdapterRegistry, IModel, Metamodel } from 'shell-models-lib';
import { KustoDatabaseCopySource } from 'app/model/pipeline/copysource/kusto-database.copysource';
import { commonCopySourceAdapts } from 'app/model/adapters/activities/copysource/copysource.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(KustoDatabaseCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*',
        queryTimeout: '*',
        noTruncation: '*',
        // function handling is inherited from AzureDataExplorerCopySourceAdapter, so it must not fall into `raw`
        function: '*',
        functionParameters: '*'
    }
})
export class KustoDatabaseCopySourceAdapter extends AzureDataExplorerCopySourceAdapter {
    protected override model(): IModel {
        return KustoDatabaseCopySource.MODEL;
    }
}
